import React from "react";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Navbar";
import VideoEditingFaqs from "../../Components/services/video-editing/VideoEditingFaqs";
import { Link } from "react-router-dom";

const VideoEditing = () => {
  const mainColor = "#008080";
  return (
    <>
      <style>
        {`
          .text-main-color {
            color: ${mainColor};
          }
          .bg-main-color {
            background-color: ${mainColor};
          }
          .border-main-color {
            border-color: ${mainColor};
          }
          .feature-card {
            border: 1px solid #e9ecef;
            border-radius: 8px;
            padding: 1.5rem;
            margin-bottom: 1rem;
            transition: box-shadow 0.3s ease;
          }
          .feature-card:hover {
            box-shadow: 0 4px 12px rgba(0, 128, 128, 0.15);
          }
        
          .trust-section {
            background-color: #f8f9fa;
            padding: 2rem;
            border-radius: 8px;
            margin-top: 2rem;
          }
          .trust-item {
            display: flex;
            align-items: center;
            margin-bottom: 1rem;
            padding: 0.5rem;
          }
          .trust-icon {
            width: 24px;
            height: 24px;
            background-color: ${mainColor};
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 1rem;
            font-size: 12px;
          }
        `}
      </style>

      <Navbar />
      <div className="container mx-auto my-5 d-flex justify-content-center align-items-center">
        <img
          src="/images/Video Banner.jpg"
          width={800}
          height={450}
          className="rounded-4 object-fit-cover"
          alt=""
        />
      </div>

      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h2 className="text-main-color fw-bold text-center mb-4">
              Video Editing
            </h2>
            <p>
              Transform raw footage into captivating, professionally edited
              videos that tell your story with impact. Whether you're a wedding
              filmmaker, brand, or business — our video editors craft smooth,
              stylish, and emotionally engaging edits tailored to your needs.
            </p>
            <p>
              We handle everything from short-form social media content to
              cinematic highlight reels — with custom transitions, color
              grading, text overlays, and sound syncing
            </p>
            {/* Why Trust Us Section */}
            <div className="trust-section">
              <h3 className=" fw-bold text-center mb-4">
                Our video editing services include:
              </h3>

              <div className="row">
                <div className="col-md-12">
                  <div className="trust-item">
                    <div className="trust-icon">✓</div>
                    <span>Wedding films & highlight reels</span>
                  </div>
                  <div className="trust-item">
                    <div className="trust-icon">✓</div>
                    <span>Social media reels</span>
                  </div>

                  <div className="trust-item">
                    <div className="trust-icon">✓</div>
                    <span>Corporate & promo videos</span>
                  </div>
                  <div className="trust-item">
                    <div className="trust-icon">✓</div>
                    <span>Color grading, text animation & sound editing</span>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center my-4">
                <Link
                  to={"/videoediting-order"}
                  className="btn bg_maincolor text-white "
                >
                  Order Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <VideoEditingFaqs />
      <Footer />
    </>
  );
};

export default VideoEditing;
